import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const localapiSlice = createApi({
    reducerPath: 'localapi', // optional
    baseQuery: fetchBaseQuery({ baseUrl: 'http://localhost:3500' }),
    tagTypes: ['Post'],
    endpoints: builder => ({})
});